import React from 'react';
import { StyleSheet } from 'react-native';

import EdgeComboIcon from '@/assets/icons/edge-combo-icon.js';
import InfoIcon from '@/assets/icons/info-full-white.js';
import { Box, Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { common } from '@/styles/styles';

import { PlayerProfileImage } from './player-profile/PlayerProfileImage';

export type PlayerAlertOverlayProps = {
    playerImage: string;
    teamImageUrl?: string;
    secondPlayerImage?: string;
    secondTeamImageUrl?: string;
    teamColor?: string;
    teamSecondaryColor?: string;
    logoText?: string;
    secondaryLogoText?: string;
    secondTeamColor?: string;
    playerNumber?: number | null;
    secondPlayerNumber?: number | null;
    isEdgeCombo?: boolean;
    playerId: string;
    secondPlayerId?: string;
};

export const PlayerAlertOverlay = ({
    playerImage,
    teamImageUrl,
    secondPlayerImage,
    secondTeamImageUrl,
    teamColor,
    teamSecondaryColor,
    secondTeamColor,
    logoText,
    secondaryLogoText,
    playerNumber,
    secondPlayerNumber,
    isEdgeCombo,
    playerId,
    secondPlayerId,
}: PlayerAlertOverlayProps) => {
    return (
        <Row>
            <PlayerProfileImage
                playerImageUrl={playerImage}
                teamImageUrl={teamImageUrl}
                style={styles.playerImage}
                teamColor={teamColor}
                teamSecondaryColor={teamSecondaryColor}
                bgColor={ds.colorToken.background.neutral.subtle}
                logoText={logoText}
                playerNumber={playerNumber}
                playerId={playerId}
            />
            <Row
                borderRadius={'r10'}
                justifyContent={'center'}
                alignItems={'center'}
                style={[common.zIndex1, common.borderCurve]}
            >
                {isEdgeCombo ? (
                    <Box
                        backgroundColor={ds.colorToken.background.neutral.inverse}
                        borderRadius={'r16'}
                        width={32}
                        height={32}
                        alignItems={'center'}
                        justifyContent={'center'}
                        style={common.borderCurve}
                    >
                        <EdgeComboIcon />
                    </Box>
                ) : (
                    <InfoIcon width={32} height={32} />
                )}
            </Row>
            {secondPlayerImage && secondPlayerId ? (
                <Box style={[styles.secondPlayerImage, common.zIndex0]}>
                    <PlayerProfileImage
                        playerImageUrl={secondPlayerImage}
                        teamImageUrl={secondTeamImageUrl}
                        teamColor={secondTeamColor}
                        bgColor={ds.colorToken.background.neutral.subtle}
                        logoText={secondaryLogoText}
                        playerNumber={secondPlayerNumber}
                        playerId={secondPlayerId}
                    />
                </Box>
            ) : null}
        </Row>
    );
};

const styles = StyleSheet.create({
    secondPlayerImage: {
        transform: [{ translateX: -13 }],
    },
    playerImage: {
        transform: [{ translateX: 13 }],
    },
});
